import { CommonModule, NgIf } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppMaterialModule } from 'src/app/app-material.module';
import { RequestService } from 'src/app/services/request/request.service';

export class VccSearchModel {
  public vccId: number;
  public vccName: string;
}
@Component({
  selector: 'app-vcc-request-search-modal',
  templateUrl: './vcc-request-search-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    AppMaterialModule,
    MatOptionModule,
    NgIf,
    ReactiveFormsModule,
  ],
  styleUrls: ['../request-target-search.component.scss'],
})
export class VccRequestSearchModalComponent implements OnInit {
  @Output() selectedOptionChange: EventEmitter<VccSearchModel | null> =
    new EventEmitter();

  typeAheadOptions: VccSearchModel[] = [];
  selectedOption: VccSearchModel | null = null;
  inputFormControl: FormControl = new FormControl('', [Validators.required]);

  constructor(private requestService: RequestService) {}

  ngOnInit(): void {
    this.inputFormControl.setValidators([
      Validators.required,
      this.contractNumberValidator.bind(this),
    ]);
    this.inputFormControl.setValue('');

    this.typeAheadOptions = [];
    this.selectedOption = null;

    this.inputFormControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        this.searchTypeAheadOptions(value);

        // Clear selected option when user types
        if (value != this.selectedOption?.vccName) {
          this.selectedOption = null;
        }

        if (this.selectedOption === null) {
          this.selectedOptionChange.emit(null);
        }
      });
  }

  searchTypeAheadOptions(inputValue: string) {
    if (inputValue.length > 2) {
      this.requestService.getVccSearchResults(inputValue).then(options => {
        this.typeAheadOptions = options;
      });
    }
  }

  onOptionSelected(selectedOption: VccSearchModel) {
    this.selectedOption = selectedOption;
    this.inputFormControl.setValue(selectedOption.vccName);
    this.selectedOptionChange.emit(this.selectedOption);
  }

  contractNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value == null || control.value === '') {
      return null;
    }

    if (control.value !== this.selectedOption?.vccName) {
      return { invalidVcc: true };
    }
    return null;
  }
}
